<div class="container">
  <div class="row">
    <div class="s12">
      <div class="btn-group--fill">
        <button *ngIf="processedImage == 0 && totalFrames == 0" class="btn btn-secondary" (click)="exportMyCollection()" type="button" mat-button>
          Print My Collection
        </button>
        <div class="container text-center"
             *ngIf="processedImage > 0 || totalFrames > 0">
          <p>Generating PDF Report. Processing {{processedImage}} of {{totalFrames}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
